export default __webpack_public_path__ + "6de7d4b539221a49e9e241b734653ecf.ttf";